import veritoneApi from './veritoneApi';
import { get, chunk, isError } from 'lodash';
import { TYPE_DMA, TYPE_RADIOMETRO } from 'components/Geofence/constant';
import { UNRATED_FIELDS } from './constant';

export const STATION_DEFAULT_SOURCE_TYPE_IDS = [1, 2];
export const STATION_DEFAULT_PERMISSION = 'viewer';

const DMA_UNRATED_KEY = UNRATED_FIELDS[TYPE_DMA];
const METRO_UNRATED_KEY = UNRATED_FIELDS[TYPE_RADIOMETRO];

function genGetStationQuery(limit, offset) {
  return `
  {
    sources(
      sourceTypeIds: ${JSON.stringify(STATION_DEFAULT_SOURCE_TYPE_IDS)},
      permission: ${STATION_DEFAULT_PERMISSION},
      limit: ${limit},
      offset: ${offset},
      includePublic: false,
      orderBy: {
        field: id,
        direction: desc
      }
    ) {
      records {
        id
        name
        sourceTypeId
        details
      }
      count
    }
  }`
}

export async function getOrgStationsApi(urlApi, index = 0, limit = 100) {
  try {
    const response = await veritoneApi(urlApi.graphql).post(
      '',
      { query: genGetStationQuery(limit, index) }
    );

    const { error } = response;
    if (error) {
      return { error };
    }

    const stations = get(response, 'data.data.sources.records', []);
    if ( stations.length === limit ) {
      const newIndex = index + limit;
      const moreStations = await getOrgStationsApi(urlApi, newIndex, limit );
      const newStationList = [...stations, ...moreStations.data];
      return { data: newStationList };
    } else {
      return { data: stations };
    }
  } catch (error) {
    return { error };
  }
}

export function getMarketApi(urlApi, source, stationCallsigns = [], chunkSize = 100) {
  if (chunkSize >= 0) {
    return new Promise( async (resolve, reject) => {
      const result = await loadMarketByChunk(urlApi, source, stationCallsigns, chunkSize);
      resolve(result);
    })
  } else {
    const stationInfo = {
      source,
      stationCallsigns
    }
    return loadMarkets(urlApi, stationInfo);
  }
}

export function fetchIHeartTTWNMarkets(urlApi, type = '') {
  return veritoneApi(urlApi.baseUrl)
    .get(`/ih_ttwn_markets${type && `?type=${type}`}`)
    .then(response => {
      const ttwnMarkets = get(response, 'data.data', []);
      return ttwnMarkets;
    })
    .catch(error => {
      console.error('Failed to get iHeart TTWN markets');
      return [];
    });
}

export function loadMarkets(urlApi, stationInfo) {
  return veritoneApi(urlApi.baseUrl)
    .post(`/markets/`, stationInfo)
    .then(response => response.data)
    .catch(error => error);
}

export async function loadMarketByChunk(urlApi, source, stationCallsigns = [], chunkSize) {
  const stationCallsignByChunk = chunk(stationCallsigns, chunkSize);
  let responseByChunk = [];
  const chunkNumberToLoad = 3;
  while(stationCallsignByChunk.length > 0) {
    const chunkToLoad = stationCallsignByChunk.splice(0, chunkNumberToLoad);
    const results =  await Promise.all(chunkToLoad.map(stationChunk => {
      const stationInfo = {
        source,
        stationCallsigns: stationChunk
      }
      return loadMarkets(urlApi, stationInfo);
    }))
    .then(responses => responses)
    responseByChunk = [...responseByChunk, ...results];
  }
  const data = processMarketHashMap(responseByChunk)
  return { data };
}

function processMarketHashMap(responseByChunk) {
  const marketHashMap = {};
  for (let i = 0; i < responseByChunk.length; i++) {
    const response = responseByChunk[i];
    if (!response || isError(response) || response.code !== 'SUCCESS') {
      continue;
    }

    const marketByChunk = get(response, 'data', {});
    for (const marketId in  marketByChunk ) {
      const marketData =  marketByChunk[marketId] || {};
      if (!marketHashMap[marketId]) {
        marketHashMap[marketId] = marketData;
      } else {
        const market = marketHashMap[marketId] || {};
        const {
          stations: prevStations,
          [DMA_UNRATED_KEY]: prevUnratedDMA,
          [METRO_UNRATED_KEY]: prevUnratedMetro,
        } = market;
        const {
          stations: newStations,
          [DMA_UNRATED_KEY]: newUnratedDMA,
          [METRO_UNRATED_KEY]: newUnratedMetro,
        } = marketData;
        market.stations = [...prevStations, ...newStations];
        market[DMA_UNRATED_KEY] = prevUnratedDMA || newUnratedDMA;
        market[METRO_UNRATED_KEY] = prevUnratedMetro || newUnratedMetro;
      }
    }
  }

  return marketHashMap;
}
